//所有有关用户信息的网络请求
import http from '../utils/http'



//管理员用的接口(改成统一查询全部的接口)
export function apiAllListinginfo({page,size}){
    return http({
      url:`/user/listing/${page}/${size}`,
      method:'get',
    })
  }

//销售用的接口
// export function apiOneListinginfo({page,size,name}){
//   return http({
//     url:`/user/listing/${name}/${page}/${size}`,
//     method:'get',
//   })
// }

//根据id查询
export function apiListingInfo(listingId){
  return http({
    url:`/user/listing/${listingId}`,
    method:'get',
  })
}


//分页+多条件查询（销售用的接口）
// export function apiSearchOneListingList({page,size,name}){
//   return http({
//     url:`/user/listing/${name}/${page}/${size}`,
//     method:'get',
//   })
// }

//分页+多条件查询(统一查询全部的数据)
export function apiSearchListingList(params){
  return http({
    url:`/user/listing`,
    method:'get',
    params: params
  })
}

//新增
export function apiAddListingList(data){
  return http({
    url:'/user/listing',
    method:'POST',
    data
  })
}
//编辑
export function apiEditListingList(listingId,data){
  return http({
    url:`/user/listing/${listingId}`,
    method:'put',
    data
  })
}
//删除
export function apiDeleteListingList(id){
  return http({
    url:`/user/listing/${id}`,
    method:'delete',
  })
}

//导入
export function apiImportFile(params){
  return http({
    url:'/user/listing/upload',
    method:'post',
    data:params,
    headers:{
      'content-type':'multipart/form-data'
    }
  })
}

//导出
export function exportTable(params){
  return http({
    url:`/user/listing/download`,
    method:'get',
    params:params,
    responseType:'blob'
  })
}


  